module.exports = __webpack_public_path__ + "img/首单优惠示例图.4e62b000.jpeg";